<template>
    <div class="table offer-info">
        <div v-for="round in rounds" v-if="round.ssrRoundSupplierLogistics.length>0">
            <div>Round {{round.roundNumber}}
                <!--下载本轮次Excel-->
                <el-button type="primary" @click="offerDownload(round.ttSsrRoundId)">{{$t('ssrManage.offerDownload')}}</el-button>
            </div>
            <logistic-info-table :data.sync="round.ssrRoundSupplierLogistics" :can-edit="canEdit"></logistic-info-table>
        </div>
        <!--底部操作按钮-->
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button v-if="roundIds.length>1" type="primary" @click="offerDownload(roundIds)">Download All</el-button>
        </el-row>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import LogisticInfoTable from "@/components/page/ssr-manage/logistic-info-table";
    import commonFun from "@/utils/commonFun";

    export default {
        name: '',
        extends: commonMethods,
        components: {LogisticInfoTable},
        props: {
            rounds: Array
        },
        computed: {
            canEdit() {
                return false;
            },
            roundIds() {
                return this.rounds.filter(round=>round.ssrRoundSupplierLogistics.length>0).map(round=>round.ttSsrRoundId);
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            offerDownload(roundIds){
                apiService.exportLogistic(roundIds);
            }
        }
    }
</script>
<style scoped>
</style>
